"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWN_CHILD_SEAT_COUNTRIES = exports.CASH_ONLY_COUNTRIES = exports.PORTUGAL_COUNTRY_ID = exports.CUBA_COUNTRY_ID = exports.ITALY_COUNTRY_ID = exports.MAIN_CUSTOMER_COUNTRY_ISO_CODE = void 0;
exports.MAIN_CUSTOMER_COUNTRY_ISO_CODE = ["us", "ca", "au", "sg", "ph"];
exports.ITALY_COUNTRY_ID = "d277bb75-67b1-4e73-9a96-b9b5117b22d2";
exports.CUBA_COUNTRY_ID = "515bba0e-5cc5-4db2-b9f9-e09a0fdadd35";
exports.PORTUGAL_COUNTRY_ID = "9b3a6e5f-f4c7-4e0c-b9a4-99f09c33d561";
/**
 * in countries like Cuba we have only cash payment option.
 * enforcing the deposit is the only way we can get our Daytrip fee transferred to us
 */
exports.CASH_ONLY_COUNTRIES = [exports.CUBA_COUNTRY_ID];
/**
 * in countries like US the customer has to bring their own child seat
 */
exports.OWN_CHILD_SEAT_COUNTRIES = ["us"];
//# sourceMappingURL=countries.js.map